<template>
  <div class="main-layout">
    <side-bar v-if="showPageNavigation"/>
    <main class="main-window"
      :class="{
        'authenticated': showPageNavigation
      }">
      <section class="main-content">
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
      </section>
    </main>
  </div>
</template>

<script>
import SideBar from './SideBar'
import { startCase } from 'lodash'

export default {

  components: {
    SideBar
  },

  data: () => ({
    title: ''
  }),

  created() {
    let name = this.$route.name ?? ''
    this.title = startCase(name.replace('-', ' '))

    this.$bus.$on('set-title', (title) => {
      this.title = title
      document.title = `Snitch • ${this.title}`
    })
  },

  beforeRouteUpdate(to, from, next) {
    this.setTitle(to)
    next()
  },

  methods: {
    setTitle(route = null) {
      this.title = (to || this.$route).name.replace('-', ' ')
      document.title = `Snitch • ${this.title}`
    },
  },

  computed: {
    showPageNavigation() {
      return !['signin', 'signup', 'device', 'reset-password', 'forgot-password', '2fa-challenge'].includes(this.$route.name)
    }
  }

}
</script>
